<template>
  <ProductShowcase
    v-if="products.length"
    data-test-id="similar-events"
    class="my-12"
    :gtm-item-list-id="GtmItemListId.EventPageSimilarClasses"
    :products="products"
    :loading="pending"
    :tags="[]"
    :title="similarEventsTitle"
    :title-level="2"
    :use-h-tag="true"
    :algolia-insights-client="insightsClient"
    algolia-insights-label="Similar Events - Event Page"
  />
</template>
<script setup lang="ts">
import { GtmItemListId } from '~/composables/useKftGtm/types'

const {
  isGiftcard,
  displayMode = 'rest',
} = defineProps<{
  isGiftcard: boolean
  displayMode?: 'rest' | 'all'
}>()

const { client: insightsClient } = useAlgoliaSearchInsights()
const { restSimilarEvents, allSimilarEvents, pending } = useEventSimilarEvents()
const similarEventsTitle = useSimilarEventsTitle(isGiftcard)

const products = computed(() =>
  displayMode === 'all' ? allSimilarEvents.value : restSimilarEvents.value
)
</script>
